import { render, staticRenderFns } from "./ProgramarCurso.vue?vue&type=template&id=56521666&scoped=true"
import script from "./ProgramarCurso.vue?vue&type=script&lang=js"
export * from "./ProgramarCurso.vue?vue&type=script&lang=js"
import style0 from "./ProgramarCurso.vue?vue&type=style&index=0&id=56521666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56521666",
  null
  
)

export default component.exports